import { render } from "./mvt-autocomplete.vue?vue&type=template&id=40e44c7a"
import script from "./mvt-autocomplete.js?vue&type=script&lang=js"
export * from "./mvt-autocomplete.js?vue&type=script&lang=js"

import "./mvt-autocomplete.vue?vue&type=style&index=0&id=40e44c7a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__